import { useLogout } from "ra-core";
import { Clock3, LogOut, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export const AccessPending = () => {
  const logout = useLogout();
  const retry = () => {
    window.sessionStorage.removeItem("RaStore.auth.current_sale");
    window.location.assign("/");
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-neutral-50 p-6 text-neutral-950">
      <section className="w-full max-w-md border border-neutral-200 bg-white p-8 text-center shadow-sm">
        <img
          className="mx-auto mb-6 size-16 object-contain"
          src="/baskerville-favicon.png"
          alt="BaskervilleAI"
        />
        <Clock3 className="mx-auto mb-4 size-6" aria-hidden="true" />
        <h1 className="text-2xl font-semibold">Acceso pendiente</h1>
        <p className="mt-3 text-sm leading-6 text-neutral-600">
          Tu cuenta de Google fue autenticada, pero un administrador debe
          autorizarla antes de entrar al workspace BaskervilleAI.
        </p>
        <div className="mt-6 flex justify-center gap-2">
          <Button onClick={retry}>
            <RefreshCw className="size-4" aria-hidden="true" />
            Verificar acceso
          </Button>
          <Button variant="outline" onClick={() => logout()}>
            <LogOut className="size-4" aria-hidden="true" />
            Cerrar sesión
          </Button>
        </div>
      </section>
    </main>
  );
};
